"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemsReducer = void 0;

var _deepFreeze = _interopRequireDefault(require("deep-freeze"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var itemsReducer = function itemsReducer(items, action) {
  var _items = _toConsumableArray(items);

  var type = action.type,
      value = action.value;

  switch (type) {
    case 'SET_ITEMS':
      _items = value.items;
      break;

    case 'SET_ITEM':
      _items[value.index] = value.item;
      break;

    default:
      throw new Error("Unsupported action type: ".concat(action.type));
  }

  return (0, _deepFreeze.default)(_items);
};

exports.itemsReducer = itemsReducer;